import { Component, OnInit, ViewChild, ElementRef, Input, Signal, effect, ChangeDetectorRef, Type } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Agent, AgentServicev2 } from '../agent-builder-services/agent.service';
import { KnowledgeBaseService, KnowledgeBase } from '../agent-builder-services/knowledge-base.service';
import { SearchInputNewComponent, SearchProperties } from 'src/app/system-utils/search-input-new/search-input-new.component';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { Variable } from 'src/app/forms/formula-tester/formula-tester.component';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { FormServices } from 'src/app/services/form.services';
import { ModalOptions, NzModalService } from 'ng-zorro-antd/modal';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { GlobalErrorHandler } from 'src/app/services/GloabalErrorHandler.services';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { PromptMessage } from '../agent-builder-model/agent-config';
import { AgentBuilderDatabaseComponent } from '../agent-builder-database/agent-builder-database.component';
import { REGISTRY } from 'src/app/interfaces/registry-services';
import { CronFormComponent } from 'src/app/forms/cron-form/cron-form.component';


@Component({
  selector: 'agent-builder-config',
  templateUrl: './agent-builder-config.component.html',
  styleUrls: ['./agent-builder-config.component.scss'],
  standalone: false
})
export class AgentBuilderConfigComponent implements OnInit {

  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('tableMcp') tableMcp: NzTableComponent<any> = null;
  @ViewChild('tableGoal') tableGoal: NzTableComponent<any>;
  @ViewChild('tableHHeader') tableHHeader: NzTableComponent<any>;
  @ViewChild('searchInputIdhook') searchInputIdhook: SearchInputNewComponent;

  mcpForm!: FormGroup;
  loading = false;
  mcpLoading = false;
  kbLoading = false;
  @Input() form:FormGroup
  @Input() editSubject: BehaviorSubject<boolean> | null = null;

  selectedMcps: string[] = [];
  knowledgeBaseFiles: KnowledgeBase[] = [];
  showMcpModal = false;
  editingIndexMcp: number | null = null;
  models = [];
  embeedModels = [];
  /** servidores cadastrados, para escolher quem executa o agente autonomo */
  servidores = [];
  modelsData:BehaviorSubject<Object[]> = new BehaviorSubject<Object[]>([]);
  variables:Variable[] = [];
  mcpPageIndex = 1;
  mcps: any[] = [];
  oldForm:Agent;
  listOfTool:any[] = [];
  loadingMcp:boolean = false;
  /**
   * O botao de salvar some nos passos que nao editam o agente: testar e
   * historico. Derivado do passo atual, e nao guardado em campo - assim nao ha
   * indice para manter em sincronia quando um passo novo entra no meio.
   */
  get showSaveButton(): boolean {

    let chave = this.passos[this.passoAtual]?.chave;

    return chave !== 'teste' && chave !== 'historico' && chave !== 'execucoes'
        && chave !== 'candidatos';
  }
  backupSystemPrompt:string = null;
  historySelected:number = -1;
  canRedoSystemPrompt = false;

  /**
   * Secoes do construtor de prompt, na MESMA ordem em que o Java as concatena
   * (OrchestratorPromptBuilder). Entre Estrategia e Regras o Java insere
   * automaticamente a lista de agentes permitidos — por isso nao ha secao para isso.
   */
  secoesDoPrompt = [
    {
      campo: 'sectionFixedCore',
      titulo: 'agentBuilder.promptBuilder.fixedCore',
      ajuda: 'agentBuilder.promptBuilder.fixedCore.hint',
      aberta: true
    },
    {
      campo: 'sectionIdentity',
      titulo: 'agentBuilder.promptBuilder.identity',
      ajuda: 'agentBuilder.promptBuilder.identity.hint',
      aberta: false
    },
    {
      campo: 'sectionStrategy',
      titulo: 'agentBuilder.promptBuilder.strategy',
      ajuda: 'agentBuilder.promptBuilder.strategy.hint',
      aberta: false
    },
    {
      campo: 'sectionRules',
      titulo: 'agentBuilder.promptBuilder.rules',
      ajuda: 'agentBuilder.promptBuilder.rules.hint',
      aberta: false
    },
    {
      campo: 'sectionStyle',
      titulo: 'agentBuilder.promptBuilder.style',
      ajuda: 'agentBuilder.promptBuilder.style.hint',
      aberta: false
    },
    {
      campo: 'sectionSafety',
      titulo: 'agentBuilder.promptBuilder.safety',
      ajuda: 'agentBuilder.promptBuilder.safety.hint',
      aberta: false
    }
  ];

  // ============================================================
  // Passo a passo da criacao do agente
  //
  // A ordem segue o que o usuario precisa decidir primeiro: sem modelo
  // nao ha agente, sem prompt ele nao sabe o que fazer, e so faz sentido
  // testar depois que o agente esta salvo.
  // ============================================================

  passoAtual: number = 0;

  /**
   * Ligado pelo componente do dicionario: fica true quando existe ao menos um
   * termo COM sinonimo. Termo sem sinonimo nao casa com pergunta nenhuma.
   */
  dicionarioTemCuradoria = false;

  /**
   * Os passos, em dois grupos.
   *
   * "montar" e o que define o agente; "acompanhar" e o que so faz sentido
   * depois que ele existe e roda. Separar os dois evita a lista corrida de dez
   * itens, em que configuracao e diagnostico apareciam com o mesmo peso.
   */
  passos = [
    { chave: 'identidade',  titulo: 'agentBuilder.step.identity',   opcional: false, grupo: 'montar' },
    { chave: 'prompt',      titulo: 'agentBuilder.step.prompt',     opcional: false, grupo: 'montar' },
    { chave: 'conhecimento',titulo: 'agentBuilder.step.knowledge',  opcional: true,  grupo: 'montar' },
    { chave: 'dicionario',  titulo: 'agentBuilder.step.dictionary', opcional: true,  grupo: 'montar' },
    { chave: 'ferramentas', titulo: 'agentBuilder.step.tools',      opcional: true,  grupo: 'montar' },
    { chave: 'subagentes',  titulo: 'agentBuilder.step.subagents',  opcional: true,  grupo: 'montar' },
    { chave: 'teste',       titulo: 'agentBuilder.step.test',       opcional: true,  grupo: 'acompanhar' },
    { chave: 'historico',   titulo: 'agentBuilder.step.history',    opcional: true,  grupo: 'acompanhar' },
    { chave: 'execucoes',   titulo: 'agentBuilder.step.executions', opcional: true,  grupo: 'acompanhar' },
    { chave: 'candidatos',  titulo: 'agentBuilder.step.candidates', opcional: true,  grupo: 'acompanhar' }
  ];

  /**
   * Etapas conhecidas do pipeline, na ordem padrao.
   * O rotulo diz o que a etapa busca, e nao o nome tecnico dela.
   */
  etapasDoPipeline = [
    { chave: 'glossario', titulo: 'agentBuilder.pipeline.glossario' },
    { chave: 'kb',        titulo: 'agentBuilder.pipeline.kb' },
    { chave: 'feedback',  titulo: 'agentBuilder.pipeline.feedback' },
    { chave: 'userdoc',   titulo: 'agentBuilder.pipeline.userdoc' }
  ];

  /** a lista gravada no agente, sempre como array */
  private get pipelineAtual(): string[] {

    let valor = this.form?.get('pipeline')?.value;

    if (Array.isArray(valor)) {
      return valor as string[];
    }

    return [];
  }

  /** true quando a etapa esta ligada para este agente */
  etapaLigada(chave: string): boolean {
    return this.pipelineAtual.indexOf(chave) >= 0;
  }

  /** quantas etapas o agente consulta hoje */
  get quantidadeLigadas(): number {
    return this.pipelineAtual.length;
  }

  /**
   * As etapas na ordem em que rodam, com as desligadas no fim.
   *
   * A posicao vem da lista gravada, e nao do catalogo: e ela que o Java
   * percorre, e o que vem por ultimo fica colado na pergunta.
   */
  get etapasOrdenadas(): any[] {

    let atual = this.pipelineAtual;
    let ligadas = [];
    let desligadas = [];

    for (let chave of atual) {

      let etapa = this.etapasDoPipeline.find(e => e.chave === chave);

      if (etapa != null) {
        ligadas.push({ chave: etapa.chave, titulo: etapa.titulo, posicao: ligadas.length + 1 });
      }
    }

    for (let etapa of this.etapasDoPipeline) {

      if (atual.indexOf(etapa.chave) < 0) {
        desligadas.push({ chave: etapa.chave, titulo: etapa.titulo, posicao: 0 });
      }
    }

    return ligadas.concat(desligadas);
  }

  /**
   * Liga ou desliga uma etapa.
   *
   * Ao ligar, a etapa entra no FIM da lista: e a posicao mais influente, e
   * quem acabou de liga-la costuma querer que ela pese. Reordenar depois e um
   * clique nas setas.
   */
  alternarEtapa(chave: string): void {

    let atual = this.pipelineAtual.slice();
    let posicao = atual.indexOf(chave);

    if (posicao >= 0) {
      atual.splice(posicao, 1);
    } else {
      atual.push(chave);
    }

    this.gravarPipeline(atual);
  }

  /**
   * Move a etapa uma posicao para cima (-1) ou para baixo (1).
   *
   * So mexe em etapa ligada: a desligada nao esta na lista e nao tem posicao.
   */
  moverEtapa(chave: string, direcao: number): void {

    let atual = this.pipelineAtual.slice();
    let de = atual.indexOf(chave);

    if (de < 0) {
      return;
    }

    let para = de + direcao;

    if (para < 0 || para >= atual.length) {
      return;
    }

    let removida = atual.splice(de, 1)[0];
    atual.splice(para, 0, removida);

    this.gravarPipeline(atual);
  }

  private gravarPipeline(nova: string[]): void {
    this.form.get('pipeline').setValue(nova);
    this.form.get('pipeline').markAsDirty();
  }

  /** os passos de um grupo, com o indice real preservado para a navegacao */
  passosDoGrupo(grupo: string): any[] {

    let resultado = [];

    for (let i = 0; i < this.passos.length; i++) {
      if (this.passos[i].grupo === grupo) {
        resultado.push({ passo: this.passos[i], indice: i });
      }
    }

    return resultado;
  }

  irParaPasso(indice: number): void {
    if (indice < 0) {
      return;
    }
    if (indice > this.passos.length - 1) {
      return;
    }
    this.passoAtual = indice;
  }

  passoAnterior(): void {
    this.irParaPasso(this.passoAtual - 1);
  }

  proximoPasso(): void {
    this.irParaPasso(this.passoAtual + 1);
  }

  /** o passo tem tudo o que precisa para funcionar? */
  passoEstaPronto(chave: string): boolean {

    if (chave === 'identidade') {
      return this.campoPreenchido('agentName')
          && this.campoPreenchido('llm')
          && this.campoPreenchido('model')
          && this.campoPreenchido('apiKey');
    }

    if (chave === 'prompt') {
      if (this.form.get('usePromptBuilder').value === true) {
        // no construtor, basta a identidade do agente estar escrita
        return this.temConteudo('sectionIdentity');
      }
      return this.campoPreenchido('systemPrompt');
    }

    if (chave === 'conhecimento') {
      return this.campoPreenchido('dbName')
          && this.campoPreenchido('kbTable')
          && this.campoPreenchido('kbVectorIndexName');
    }

    // so conta como pronto quando ha termo COM sinonimo: termo sem sinonimo
    // nunca casa com a pergunta, entao nao muda nada no Java
    if (chave === 'dicionario') {
      return this.agent != null && this.agent._id != null && this.dicionarioTemCuradoria;
    }

    if (chave === 'ferramentas') {
      let mcps = this.form.get('mcps').value;
      return mcps != null && mcps.length > 0;
    }

    if (chave === 'subagentes') {
      let agentes = this.form.get('allowedAgents').value;
      return agentes != null && agentes.length > 0;
    }

    // testar, historico e execucoes so existem depois que o agente foi salvo
    if (chave === 'teste' || chave === 'historico' || chave === 'execucoes'
            || chave === 'candidatos') {
      return this.agent != null && this.agent._id != null;
    }

    return false;
  }

  /** status usado pelo nz-step: finish (pronto), process (atual) ou wait (pendente) */
  statusDoPasso(indice: number): string {

    if (this.passoEstaPronto(this.passos[indice].chave)) {
      return 'finish';
    }

    if (indice === this.passoAtual) {
      return 'process';
    }

    return 'wait';
  }

  /** legenda abaixo do titulo do passo */
  legendaDoPasso(indice: number): string {

    if (this.passoEstaPronto(this.passos[indice].chave)) {
      return 'agentBuilder.step.done';
    }

    if (this.passos[indice].opcional) {
      return 'agentBuilder.step.optional';
    }

    return 'agentBuilder.step.pending';
  }

  private campoPreenchido(nome: string): boolean {

    let controle = this.form.get(nome);
    if (controle == null) {
      return false;
    }

    let valor = controle.value;
    if (valor == null) {
      return false;
    }

    return String(valor).trim().length > 0;
  }

  /** a secao tem texto de verdade? (o quill grava "<p><br></p>" quando esta vazio) */
  temConteudo(campo: string): boolean {

    let grupo = this.form.get('promptBuilder');
    if ( grupo == null ) {
      return false;
    }

    let controle = grupo.get(campo);
    if ( controle == null || controle.value == null ) {
      return false;
    }

    let texto = String(controle.value);
    texto = texto.replace(/<[^>]*>/g, '');
    texto = texto.replace(/&nbsp;/g, ' ');

    return texto.trim().length > 0;
  }
  filteredListOfTool: any[] = [];
  localSub:Subscription;
  agentModelsSub:Subscription;
  servidoresSub:Subscription;

  constructor(
    private agentServiceV2: AgentServicev2,
    private uas:UserAuthenticationServices,
    private message: NzMessageService,
    private ls: LanguageServices,
    private formServices:FormServices,
    private fb: FormBuilder,
    private modal: NzModalService,
    
  ) {

  }

  ngOnDestroy(): void {
    if ( this.localSub!=null){
      this.localSub.unsubscribe();
    }
    if ( this.servidoresSub!=null){
      this.servidoresSub.unsubscribe();
    }

    if ( this.agentModelsSub!=null){
      this.agentModelsSub.unsubscribe();
    }
  }

fixDate(d: any) {
  if (d instanceof Date) {
    return d;
  }

  if (typeof d === 'string' && d.trim() !== '') {
    return new Date(d.replace('BRT', 'GMT-0300'));
  }

  return new Date();
}


selectHistoryPrompt(){
  if ( this.historySelected>-1 ){
    let history:PromptMessage = (this.form.get("systemPromptHistory").value as any[])[this.historySelected]
    this.form.get("systemPrompt").setValue(history.systemPrompt);
  }
}



onChangeTools(event){
    if ( this.searchInputIdhook==null){
      return;
    }
  
    this.loadMcpHook(event.key);
}

loadModels(){
    return new Promise((resolve,reject)=>{
      this.agentModelsSub = this.agentServiceV2.loadLlmModels().subscribe({

        next:(res:any)=>{
            this.modelsData.next(res['SQL']||[]);
            let selectedModel:any = this.modelsData.value.find(m => m['llm'] === this.form.get('llm')?.value);
            if ( selectedModel!= null){
                this.models = selectedModel.models;
                this.embeedModels = selectedModel.embeedModels;
            }
            resolve(true);
          },
        error:(err)=>{
            this.message.error(this.ls.instant("agentBuilder.errorLoadingModels"));
            reject(err);
        }
      });
    })
    
}

loadMcpHook(idHook){
    let filtered = this.searchInputIdhook?.list.filter(f=>f.IDHOOK==idHook);
    this.listOfTool = [];
    this.filteredListOfTool = [];
    if (filtered.length > 0){
      let expression:any = JSON.parse(filtered[0].EXPRESSION);
      if ( expression.services){
        if ( expression.type == "mcp"){
            for ( let service of expression.services){
                let tool = {
                    name: service.serviceName,
                    description: service.description,
                    arguments: service.jsonSchema
                }
                let index = this.listOfTool.findIndex(t=>t.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value?.key) );
                if ( index == -1 ){
                    this.listOfTool.push({
                        id: (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value?.key),
                        tools: [tool]
                    });
                }else{
                    this.listOfTool.find(d=>d.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value.key))?.tools.push(tool);
                }
            }
        }
      }
    }
    
    this.filteredListOfTool = this.listOfTool.filter(d=>d.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value?.key));
}
ngOnInit(): void {

  setTimeout(async ()=>{
    await this.loadModels();
    this.form.get('llm')?.valueChanges.subscribe(value => {
        this.onLlmChange(value);
    });

    if (!this.form.get('mcps')) {
        this.form.addControl('mcps', []);
    }
    this.mcps =  (this.form.get('mcps')?.value ?? []) as any[];
    this.oldForm = this.form.getRawValue() as Agent;

    if ( this.form.get('_id')?.value){
        this.onLlmChange(this.form.get('llm')?.value);
    }

    if ( this.form.get("systemPrompt").value!= null){
        this.backupSystemPrompt = this.form.get("systemPrompt").value;
    }

    this.form.get('autonomo').valueChanges.subscribe(data=>{
        this.configureForm(data);
    });

    this.form.get('usePromptBuilder').valueChanges.subscribe(usa=>{
        this.configurarObrigatoriedadeDoPrompt(usa);
    });

    this.configureForm(this.form.get('autonomo').value);
    this.configurarObrigatoriedadeDoPrompt(this.form.get('usePromptBuilder').value);
    this.carregarServidores();
    this.aplicarTravaDoEmbedding();
  },100);
}

/**
 * Le os servidores cadastrados (Mktpservers).
 *
 * O Java compara o servername gravado com o HOSTNAME do servidor que roda o
 * ciclo; por isso o valor precisa vir de uma lista, e nao ser digitado.
 */
carregarServidores(){

    this.servidoresSub = this.agentServiceV2.loadServers().subscribe({
        next:(res:any)=>{
            this.servidores = res['Mktpservers'] || [];
        },
        error:(err)=>{
            console.error('Erro ao carregar os servidores:', err);
            this.servidores = [];
        }
    });
}

/**
 * Com o construtor de prompt ligado, o texto unico deixa de ser usado.
 *
 * O OrchestratorPromptBuilder monta o prompt das secoes e nem le o
 * systemPrompt - exigir o campo cheio impediria de salvar por causa de um
 * texto que nao vai a lugar nenhum.
 */
private configurarObrigatoriedadeDoPrompt(usaConstrutor: boolean): void {

    let campo = this.form.get('systemPrompt');

    if (campo == null) {
        return;
    }

    if (usaConstrutor === true) {
        campo.clearValidators();
    } else {
        campo.setValidators([Validators.required]);
    }

    campo.updateValueAndValidity({ emitEvent: false });
}

configureForm(autonomo){
    if ( autonomo ){
            this.form.get('qaTable').disable();
            this.form.get('alTable').enable();

            // sem cron e sem servidor o agente autonomo nunca e executado:
            // o Java monta a CronExpression e filtra o loadAgents por servername
            this.form.get('cron').setValidators([Validators.required]);
            this.form.get('servername').setValidators([Validators.required]);
    }else{
            this.form.get('qaTable').enable();
            this.form.get('alTable').disable();

            this.form.get('cron').clearValidators();
            this.form.get('servername').clearValidators();
    }

    this.form.get('cron').updateValueAndValidity();
    this.form.get('servername').updateValueAndValidity();
}

get agent(): Agent {
    return this.form.getRawValue() as Agent;
}

getModel(llm):any{
    return this.modelsData.value.find(m => m['llm'] === llm);
}

changeCodeContract:Subject<any> = new Subject<any>();

onChangeCodeCodeContract(evento){
        
    this.searchInputCodeCompany.disabled = true;
    this.searchDBNAME.disabled = true;
    setTimeout(()=>{
        this.searchInputCodeCompany.disabled = false;

        let variable = this.variables.find(d=>d.key=='@CODECONTRACT');

        if ( variable == null){
            this.variables.push({
                key:'@CODECONTRACT',
                value:evento?.key,
                type:'texto'
            });
        }else{
            variable.value = evento?.key;
        }
        
        this.changeCodeContract.next(evento?.key);
        this.searchDBNAME.disabled = false;
    },100);
}

searchWebHook:SearchProperties ={
        entityName:'Mktpwebhook',
        fields:{keyField:'IDHOOK', valueField:'NAME'},
        placeholder:this.ls.instant("IDHOOK"),
        showKey:true,
        size:'default',
        condition: "ACTIVE = 'S'",
        disabled:false
}

searchInputCodeCompany:SearchProperties ={
        entityName:'Mktpcompanies',
        fields:{keyField:'CODECOMPANY', valueField:'NAME'},
        placeholder:this.ls.instant("CODECOMPANY"),
        showKey:true,
        size:'default',
        condition: 'CODECONTRACT = {@CODECONTRACT}',
        disabled:true
}
  
searchInputCodeContract:SearchProperties ={
        entityName:'Mktpcontract',
        fields:{keyField:'CODECONTRACT', valueField:'CONTRACTNAME'},
        placeholder:this.ls.instant("CODECONTRACT"),
        showKey:true,
        size:'default'        
}

searchDBNAME:SearchProperties ={
    entityName:'Mktpmongodatabase',
    fields:{keyField:'_id', valueField:'databasename'},
    placeholder:this.ls.instant("agentBuilder.databasename"),
    showKey:false,
    size:'default',
    condition:"{\"codecontract.key\":{@CODECONTRACT}}",
    disabled:true,
    type:'mongo'
}

onDatabaseSelect(event){
  if ( event== null){
    return;
  }
  
  if ( this.form.get('fbTable')!= null || this.form.get('kbTable')!= null || this.form.get('qaTable')!= null || this.form.get('alTable')!= null || this.form.get('fbVectorIndexName')!= null || this.form.get('kbVectorIndexName')!= null ){
      this.modal.confirm({
          nzTitle: this.ls.instant("agentBuilder.confirmChangeDatabase"),
          nzContent: this.ls.instant("agentBuilder.confirmChangeDatabaseMessage"),
          nzOnOk: ()=>{
              
              this.form.get('fbTable').setValue(event['fbTable']);
              this.form.get('kbTable').setValue(event['kbTable']);
              this.form.get('qaTable').setValue(event['qaTable']);
              this.form.get('alTable').setValue(event['alTable']);
              this.form.get('fbVectorIndexName').setValue(event['fbVectorIndexName']);
              this.form.get('kbVectorIndexName').setValue(event['kbVectorIndexName']);
          }
      });
  }else{
      this.form.get('fbTable').setValue(event['fbTable']);
      this.form.get('kbTable').setValue(event['kbTable']);
      this.form.get('qaTable').setValue(event['qaTable']);
      this.form.get('alTable').setValue(event['alTable']);
      this.form.get('fbVectorIndexName').setValue(event['fbVectorIndexName']);
      this.form.get('kbVectorIndexName').setValue(event['kbVectorIndexName']);
  }
   
  
}

createDatabase(){ 

    this.modal.create({
        nzTitle: this.ls.instant("agentBuilder.createDatabase"),
        nzContent: AgentBuilderDatabaseComponent,
        nzData: {
            codecontract: this.form.get('codecontract')?.value,
            // o indice vetorial nasce com o tamanho do modelo escolhido; depois
            // disso o modelo fica travado, entao este valor vale para sempre
            dimensions: this.dimensoesDoEmbedding(),
        },
        nzCentered: true,
        nzCancelText: this.ls.instant("cancel"),
        nzOkText: this.ls.instant("save"),
        nzWidth: 400,
        nzOnOk: (component) =>{
          return new Promise((resolve) => {

                if (!component.form.valid) {
                    let errors = this.formServices.getFormErrors(component.form,[],"\n", 'agentBuilder');
                    this.message.error(errors);
                    resolve(false);
                    return;
                }

                this.agentServiceV2.createDatabase(component.form.value).subscribe({
                    next: (res) => {
                        this.message.success(this.ls.instant("agentBuilder.databaseCreated"));
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.message.error(this.ls.instant("agentBuilder.databaseCreationFailed"));
                        
                    }
                });
              });
                
          }
    });

}

onLlmChange(llm): void {

    let selectedModel:any = this.modelsData.value.find(m => m['llm'] === llm);
    if ( selectedModel!= null){
        this.models = selectedModel.models;
        this.embeedModels = selectedModel.embeedModels;
    }

    this.configurarBaseUrl(llm);
}

/**
 * Nome do modelo de embedding, aceitando os dois formatos do catalogo.
 *
 * O Mktpllmmodels esta sendo migrado de lista de strings para lista de
 * objetos { name, dimensions }; enquanto os dois convivem, o select precisa
 * ler qualquer um dos dois.
 */
nomeDoEmbedding(item: any): string {

    if (item == null) {
        return '';
    }

    if (typeof item === 'string') {
        return item;
    }

    return item.name ?? '';
}

/**
 * Dimensao do vetor do modelo de embedding escolhido.
 *
 * E o tamanho com que o indice do Mongo e criado. Cai em 1536 quando o
 * catalogo ainda tem o modelo como string simples - o mesmo padrao que o Java
 * assume, entao o comportamento nao muda para quem ainda nao migrou.
 */
dimensoesDoEmbedding(): number {

    let escolhido = this.form?.get('embeedModel')?.value;

    if (escolhido == null) {
        return 1536;
    }

    for (let item of (this.embeedModels ?? [])) {

        if (this.nomeDoEmbedding(item) !== escolhido) {
            continue;
        }

        if (typeof item !== 'string' && item.dimensions > 0) {
            return item.dimensions;
        }
    }

    return 1536;
}

/**
 * Somente administrador mexe na infraestrutura do agente.
 *
 * Nome do banco, colecoes, indices e chave da API: errar aqui nao da erro de
 * validacao - o agente passa a apontar para o lugar errado e para de achar
 * conteudo, ou vaza custo na conta de outra equipe.
 */
get podeEditarInfra(): boolean {
    return this.uas?.user?.profile === 'ADMIN';
}

/**
 * O modelo de embedding esta travado?
 *
 * Trava quando o agente ja foi salvo E ja tem base: os vetores gravados e o
 * indice do Mongo tem o tamanho do modelo atual. Trocar depois nao da erro -
 * a busca simplesmente para de encontrar conteudo, em silencio.
 *
 * A saida e duplicar o agente na lista e escolher outro modelo na copia, que
 * ainda nao tem base.
 */
get embeddingTravado(): boolean {
    if ( this.podeEditarInfra){
        return false;
    }
    let jaSalvo = this.form?.get('_id')?.value != null && this.form?.get('_id')?.value !== '';
    let temBase = this.form?.get('dbName')?.value != null && this.form?.get('dbName')?.value !== '';

    return jaSalvo && temBase;
}

/**
 * Aplica a trava nos dois campos que definem a dimensao do vetor.
 *
 * O llm entra junto porque e ele que define quais modelos de embedding
 * existem - trocar o provedor troca o embedding por consequencia.
 */
private aplicarTravaDoEmbedding(): void {

    let llm = this.form.get('llm');
    let embeed = this.form.get('embeedModel');

    if (llm == null || embeed == null) {
        return;
    }

    if (this.embeddingTravado) {
        llm.disable({ emitEvent: false });
        embeed.disable({ emitEvent: false });
    } else {
        llm.enable({ emitEvent: false });
        embeed.enable({ emitEvent: false });
    }
}

/**
 * Provedores que montam a URL a partir do baseUrl.
 *
 * O ConverseLlama faz baseUrl + "/chat/completions"; sem o campo preenchido a
 * chamada sai para "null/chat/completions". Nos demais o endereco vem do SDK.
 */
get precisaDeBaseUrl(): boolean {

    let llm = this.form?.get('llm')?.value;

    if (llm == null) {
        return false;
    }

    return llm.toString().toLowerCase() === 'llama';
}

/** o baseUrl so e obrigatorio para quem depende dele */
private configurarBaseUrl(llm): void {

    let controle = this.form.get('baseUrl');

    if (controle == null) {
        return;
    }

    if (llm != null && llm.toString().toLowerCase() === 'llama') {
        controle.setValidators([Validators.required]);
    } else {
        controle.clearValidators();
    }

    controle.updateValueAndValidity();
}

  /**
   * Inicializa o formulário de MCP
   */
private initMcpForm(): void {
    if ( this.localSub!=null){
      this.localSub.unsubscribe();
    }

    this.mcpForm = this.fb.group({
      idhook:[null],
      url: [''],
      header: [[]],
      tools:[[]],
      local: [false]
    });
}

private applyLocalModeRules(val: boolean, clearOpposite: boolean = true): void {
    this.switchValueMCPMode  = val;

    if ( val ){
        this.mcpForm.get('idhook').setValidators([Validators.required]);
        this.mcpForm.get('url').clearValidators();
        if (clearOpposite) {
          this.mcpForm.get('url').setValue('');
          this.mcpForm.get('tools').setValue([]);
        }
    }else{
        this.mcpForm.get('url').setValidators([Validators.required]);
        this.mcpForm.get('idhook').clearValidators();
        if (clearOpposite) {
          this.mcpForm.get('idhook').setValue(null);
          this.mcpForm.get('tools').setValue([]);
        }
    }

    this.mcpForm.get('idhook').updateValueAndValidity({ emitEvent: false });
    this.mcpForm.get('url').updateValueAndValidity({ emitEvent: false });
}

private startLocalMonitor(): void {
    this.localSub = this.mcpForm.get('local').valueChanges.subscribe(val=>{
        this.applyLocalModeRules(val, true);
    });
}

  /**
   * Abre modal para adicionar novo MCP
   */
openAddMcpModal(): void {
    this.editingIndexMcp = -1;
    this.initMcpForm();
    this.applyLocalModeRules(this.mcpForm.get('local').value, false);
    this.startLocalMonitor();
    this.filteredListOfTool = [];
    this.showMcpModal = true;
}

  getToolNames(group: any) {
    if (!group?.tools?.length) return '-';
    return group.tools.map(t => t.name).join(', ');
  }

  compareTools = (a: any, b: any) => {
    return a && b && a.name === b.name;
  };

  private waitSearchAndLoadMcpHook(idHook: string, attempt: number = 0): void {
    if (!idHook) {
      return;
    }

    if (this.searchInputIdhook?.list?.some(item => item.IDHOOK == idHook)) {
      this.loadMcpHook(idHook);
      return;
    }

    if (attempt >= 20) {
      return;
    }

    setTimeout(() => this.waitSearchAndLoadMcpHook(idHook, attempt + 1), 100);
  }



  editMcp(absoluteIndex: number): void {

    this.editingIndexMcp = absoluteIndex;
    this.initMcpForm();
    this.mcpForm.patchValue(this.mcps[absoluteIndex]);
    this.applyLocalModeRules(this.mcpForm.get('local').value, false);
    this.startLocalMonitor();

    this.filteredListOfTool = this.listOfTool.filter(d=>d.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value?.key));

    if ( this.mcpForm.get('tools')?.value!= null && this.mcpForm.get('tools')?.value.length > 0){
        //this.listOfTool.push(...this.mcpForm.get('tools')?.value);
        if ( this.filteredListOfTool.length == 0){
          this.listOfTool.push({
              id: (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value.key),
              tools: this.mcpForm.get('tools')?.value
          });
        }else{
          
          this.listOfTool.find(d=>d.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value.key))?.tools.concat(this.mcpForm.get('tools')?.value);

        }
        
        this.filteredListOfTool = this.listOfTool.filter(d=>d.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value.key));        
    }

    this.showMcpModal = true;

    if ( this.mcpForm.get('idhook').value!= null){
      this.waitSearchAndLoadMcpHook(this.mcpForm.get('idhook').value.key);
    }
  }

  formatHeader(header: any[]): string {
    if (!Array.isArray(header) || header.length === 0) return '-';
    return header.map(h => `${h.key}=${h.value}`).join(', ');
  }

  switchValueMCPMode = false;

  loadMcpTools(): void {
    if ( this.mcpForm.get('url').invalid){
        this.message.error('URL é obrigatória');
        return;
    }

    this.loadingMcp = true;

    let header:Record<string,string> = this.mcpForm.get('header').value.reduce((acc, item) => ({ ...acc, [item.key]: item.value }), {})
    this.agentServiceV2.getToolsMcp(this.mcpForm.get('url').value, header, this.agent).then(tools=>{
        if ( tools == null ){
            this.message.warning('Nenhuma ferramenta encontrada na URL informada');
            this.loadingMcp = false;
            return;
        }

        let result = null;
        if ( tools['events']!=null &&  tools['events'][0]!= null){
            result = tools['events'][0]['result'];
        }else{
            result = tools['result'];
        }

        if ( result == null ){
            this.message.warning('Nenhuma ferramenta encontrada na URL informada');
            this.loadingMcp = false;
            return;
        }
        
        for ( let tool of result['tools'] as any[]){

            let toolNormalized = null;
            if (typeof tool === 'string') {
              toolNormalized =  { name: tool };
            }else{
              toolNormalized = tool;
            }
            

            let index = this.listOfTool.findIndex(t=>t.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value) );
            if ( index == -1 ){
                this.listOfTool.push({
                    id: (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value),
                    tools: [toolNormalized]
                });
                
            }else{
                let localTool:any[] = this.listOfTool[index].tools;
                let toolIndex = localTool.findIndex(t=> t.name == toolNormalized.name);
                if ( toolIndex > -1 ){
                  localTool[toolIndex] = toolNormalized;
                }else{
                  localTool.push(toolNormalized);
                }
            }
        }
        this.filteredListOfTool = this.listOfTool.filter(d=>d.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value));
        this.loadingMcp = false;
    }).catch(error=>{
        this.loadingMcp = false;
        console.error('Erro ao buscar ferramentas:', error);
        this.message.error('Erro ao buscar ferramentas:' + GlobalErrorHandler.getMessage(error));
    });
  }



  /**
   * Salva MCP (novo ou atualizado)
   */
  saveMcp(): void {
    if (this.mcpForm.invalid) {
      let errors = this.formServices.getFormErrors(this.mcpForm,[],"\n", 'agentBuilder');
      this.message.error(errors);
      return;
    }

    if ( this.editingIndexMcp === -1){
        this.mcps = [...this.mcps, this.mcpForm.value];
    }else{
        this.mcps[this.editingIndexMcp] = this.mcpForm.value;
    }
    this.form.get('mcps')?.setValue(this.mcps);
    this.tableMcp.data = [...this.mcps];
    
    this.closeMcpModal();
  }

  deleteMcp(index): void {
    if (!index && index <0 ) {
      this.message.error('MCP inválido');
      return;
    }
    
    this.modal.confirm({
      nzTitle: 'Confirmar exclusão',
      nzContent: 'Tem certeza que deseja excluir este MCP?',
        nzOkText: 'Sim',
        nzCancelText: 'Não',
        nzOkDanger: true,
        nzOnOk: () => {
          this.mcps.splice(index, 1);
          this.tableMcp.data = [...this.mcps];
          this.form.get('mcps')?.setValue(this.mcps);

        }
    });
    
  }

  /**
   * Fecha modal
   */
  closeMcpModal(): void {
    this.showMcpModal = false;
    if ( this.localSub!=null){
      this.localSub.unsubscribe();
    }
  }

  /**
   * Abre input de arquivo
   */
  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }


  /**
   * Formata data
   */
  formatDate(date?: Date): string {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  
  /**
   * Salva agente
   */
  save(): void {
    if (this.form.invalid) {
      let errors = this.formServices.getFormErrors(this.form,[],"\n");
      this.message.error(errors);
      return;
    }

    const agentData:Agent = this.form.getRawValue() as Agent;

    this.loading = true;

    
    if ( !this.form.get("systemPrompt").pristine){
        let objectHistory = {
                systemPrompt:this.backupSystemPrompt,
                idUser:this.uas.user.iduser,
                userName: this.uas.user.username,
                updatedAt: new Date()
        };

        if (!agentData.systemPromptHistory) {
            agentData.systemPromptHistory = [objectHistory];
            } else {
            agentData.systemPromptHistory.push(objectHistory);
        }
    }

    const request = this.agent._id
      ? this.agentServiceV2.updateAgent(this.agent._id, agentData )
      : this.agentServiceV2.createAgent(agentData);

    request.subscribe({
      next: () => {
        this.loading = false;
        this.message.success(
          this.agent._id ? 'Agente atualizado com sucesso' : 'Agente criado com sucesso'
        );
        this.agentServiceV2.refreshAgents();
        this.form.markAsPristine();
        
      },
      error: (err) => {
        this.loading = false;
        console.error(err);
        this.message.error('Erro ao salvar agente:' + GlobalErrorHandler.getMessage(err));
      }
    });
  }

  closeConfig(): void {
    if ( !this.form.pristine){
      this.modal.confirm({
        nzTitle: 'Confirmar',
        nzContent: 'Deseja fechar a configuração? As alterações não salvas serão perdidas.',
          nzOkText: 'Sim',
          nzCancelText: 'Não',
          nzOnOk: () => {
            this.form.patchValue(this.oldForm);
            this.editSubject?.next(false);
            this.initMcpForm();
          }
      });
    } else {
      this.editSubject?.next(false);
    }
  }
 
  
  //HEADER DO MCP//

    newKey = '';
    newValue = '';

    addHeader() {
        if (!this.newKey) return;
        let arrayValues = this.mcpForm.get('header').value as any[];
        arrayValues = [...arrayValues, {key:this.newKey, value:this.newValue }];
        this.mcpForm.get('header').setValue(arrayValues);
        this.newKey = '';
        this.newValue = '';
    }

    removeHeader(index: number) {
        const headerArray = this.mcpForm.get('header').value as any[];
        headerArray.splice(index, 1);
        this.tableHHeader.data = [...headerArray];
        this.mcpForm.get('header').setValue(headerArray);
    }


    // goal table //

    newGoalItem;
    editGoalIndex: number | null = null;

    stopEdit() {
        this.editGoalIndex = null;
    }


    editGoal(i){
        this.editGoalIndex = i;
    }

    addGoal(){
        const v = this.newGoalItem.trim();
        if (!v) return;
        
        let arrayValues = this.form.get('goal').value as any[];
        arrayValues = [...arrayValues, v];
        this.form.get('goal').setValue(arrayValues);
        this.newGoalItem = '';

    }

    removeGoal(i){
        const goalArray = this.form.get('goal').value as any[];
        goalArray.splice(i, 1);
        this.tableGoal.data = [...goalArray];
        this.form.get('goal').setValue(goalArray);
    }

    openScheduleComponent(evento){
      
        evento.stopPropagation();

        let modalConfiguration:ModalOptions = {
            nzTitle: this.ls.instant('schedule'),
            nzContent: CronFormComponent,
            nzWidth:  '80%',
            nzClassName: 'modal-size-80',
            nzStyle: { 'top': '5px'},
            nzData: {
                action:{
                    value: this.form.get('cron').value,
                    showButtons: false
                }
            },  
            nzMask:false,
            nzOkText: this.ls.instant('OK'),
            nzCancelText: this.ls.instant('Cancel'),
            nzOnOk: (val)=>{
                
                this.form.get('cron').setValue(val);
            }, 
        }  

        let modalRef = this.modal.create(modalConfiguration);
    }
       

}